import { render, staticRenderFns } from "./ScrollToDiv.vue?vue&type=template&id=03cedd98&"
import script from "./ScrollToDiv.vue?vue&type=script&lang=js&"
export * from "./ScrollToDiv.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03cedd98')) {
      api.createRecord('03cedd98', component.options)
    } else {
      api.reload('03cedd98', component.options)
    }
    module.hot.accept("./ScrollToDiv.vue?vue&type=template&id=03cedd98&", function () {
      api.rerender('03cedd98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ay15uLUk0K6d/JS/comp/ScrollToDiv.vue"
export default component.exports